export const SYNC_BANNER_NOTIFICATION_ID = 'user-sync-required';

// A missing job is incomplete. The tech console shows the sync as enabled
// only after schedule.enabled is saved as true.
export const isSyncEnabled = (job) => {
  const record = Array.isArray(job) ? job[0] : job;
  return record?.schedule?.enabled === true;
};

// Shown only for a platform admin, only on the homepage, and only while the
// tech-console job is not enabled. An unknown status keeps the default banner.
export const shouldShowSyncBanner = ({
  platformAdmin,
  onHomePage,
  statusKnown,
  syncEnabled,
}) => {
  return Boolean(platformAdmin && onHomePage && statusKnown && !syncEnabled);
};
